module.exports = __webpack_public_path__ + "img/1.5bc306d4.png";